module.exports = __webpack_public_path__ + "static/PureScript-4a7ab88365b1d6bdaae13a16904aced1.jpg";